import {
    Col, Row
} from "antd";
import React, { useState, useEffect } from "react";
import Footer from '../footer';
import MenuLeft from '../menu';
import Navbar from '../navbar';
import PageHeaderContent from './../../commons/PageHeaderContent';
import "./index.scss";

const Register = ({ isShowActionHeader, title, link, titleNew,isOrder, isMedia = false, isCreate = true, setSearchValue, isContact = false, isModalVisible = false, setIsModalVisible, onUploadfile, isTranslate = false, ids = [], isHiddenAction, ...props }) => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <Col span={24}>
            <Navbar setToggleMenu={setToggleMenu} toggleMenu={toggleMenu} setVisible={setVisible} visible={visible} />
            <Row>
                <MenuLeft toggleMenu={toggleMenu} visible={visible} setVisible={setVisible} />
                <Col xs={24} sm={24} md={24} lg={19} xl={toggleMenu ? 22 : 20} xxl={toggleMenu ? 22 : 20} style={{ minHeight: "783px" }} className='content-main'>
                    <PageHeaderContent isShowActionHeader={isShowActionHeader} title={title} link={link} titleNew={titleNew} isOrder={isOrder} isMedia={isMedia} onUploadfile={onUploadfile} isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} isTranslate={isTranslate} ids={ids} isContact={isContact} isCreate={isCreate} setSearchValue={setSearchValue} isHiddenAction={isHiddenAction} />
                    {props.children}
                    <Footer />
                </Col>
            </Row>
        </Col>
    );
};

export default Register;
